/**
 * Mensajes del backend en texto plano.
 *
 * Muchos controladores arman el mensaje con HTML heredado de la pantalla anterior (AngularJS lo pintaba con ng-bind-html):
 * «<p>Valores de campos no validos.</p><p><strong>Campo: </strong>Nombre<p/>». El Angular nuevo lo muestra como texto, con las
 * etiquetas a la vista. Aquí se convierte a «Valores de campos no validos. Campo: Nombre».
 */

const HAY_HTML = /<\/?[a-zA-Z!]|&(#\d+|#x[0-9a-fA-F]+|[a-zA-Z]+);/;

/** ¿El texto trae etiquetas o entidades HTML? («Total < 100» no cuenta: el «<» va seguido de un espacio.) */
export function tieneHtml(texto: string): boolean {
  return HAY_HTML.test(texto);
}

function decodificarEntidades(texto: string): string {
  // DOMParser crea un documento inerte (sin scripts ni cargas de recursos); solo se lee su texto. El texto que llega ya no trae etiquetas.
  return new DOMParser().parseFromString(texto, 'text/html').documentElement.textContent ?? '';
}

const CAMPO = /^Campo:\s*(.+)$/;

export function mensajeEnTextoPlano(mensaje: unknown): string {
  if (typeof mensaje !== 'string') return '';
  if (!tieneHtml(mensaje)) return mensaje;

  const conSaltos = mensaje
    .replace(/<(script|style)[\s\S]*?<\/\1\s*>/gi, '')
    .replace(/<\/(p|li|div|tr|h[1-6])\s*>|<br\s*\/?>|<p\b[^>]*>/gi, '\n')
    .replace(/<\/?[a-zA-Z][^>]*>/g, '');

  const lineas: string[] = [];
  for (const cruda of decodificarEntidades(conSaltos).split('\n')) {
    const linea = cruda.replace(/[\s ]+/g, ' ').trim();
    if (linea && !lineas.includes(linea)) lineas.push(linea);
  }

  // «Campo: Nombre», «Campo: Codigo» → «Campos: Nombre, Codigo» (una línea de campos con error, sin repetir).
  const campos: string[] = [];
  let posicion = -1;
  const resto: string[] = [];
  for (const linea of lineas) {
    const m = CAMPO.exec(linea);
    if (m && !linea.includes('Valor:')) {
      if (posicion < 0) posicion = resto.length;
      if (!campos.includes(m[1])) campos.push(m[1]);
    } else {
      resto.push(linea);
    }
  }
  if (campos.length) {
    resto.splice(posicion, 0, `${campos.length > 1 ? 'Campos' : 'Campo'}: ${campos.join(', ')}`);
  }
  return resto.join(' ');
}
